module.exports = __webpack_public_path__ + "media/images/official/special_workcation_12-3c39fbcf6b5dc0879a2643c53ef54cdd.jpg";